import React from 'react';
import img from './Caret.svg';

const Caret = props => <img {...props} src={img} alt="caret" />;

export default Caret;
